module.exports = __webpack_public_path__ + "static/img/player_06_ph.48c608f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_06_ph.png
// module id = 40D7
// module chunks = 0